<div class="title">
    {{ "catalog_pagination_buttons_title" | translate | uppercase }}
</div>

<div class="form-row">
    <div class="form-group mb-20">
        <label class="col-xs-9 control-label">
            {{ "control_text_color" | translate }}
        </label>
        <div class="col-xs-3">
            <sp-color-picker
                [color]="textColor.value"
                [colorsPreset]="selectedThemeColors()"
                (colorChangeEvent)="setTextColor($event)"
            ></sp-color-picker>
        </div>
    </div>

    <div class="form-group mb-20">
        <label class="col-xs-9 control-label">
            {{ "control_background_color" | translate }}
        </label>
        <div class="col-xs-3">
            <sp-color-picker
                [color]="backgroundColor.value"
                [colorsPreset]="selectedThemeColors()"
                (colorChangeEvent)="setThemeBackgroundColor($event)"
            ></sp-color-picker>
        </div>
    </div>

    <div class="form-group mb-20">
        <label class="col-xs-9 control-label">
            {{ "control_contour_color" | translate }}
        </label>
        <div class="col-xs-3">
            <sp-color-picker
                [color]="borderColor.value"
                [colorsPreset]="selectedThemeColors()"
                (colorChangeEvent)="setBorderColor($event)"
            ></sp-color-picker>
        </div>
    </div>

    <div class="form-group mb-20">
        <label class="col-xs-6 control-label">
            {{ "control_radius" | translate }}
        </label>
        <div class="col-xs-6">
            <sp-input-num
                prefixImgUrl="./assets/img/border-radius-icon.svg"
                suffixText="px"
                [min]="BORDER_RADIUS_MIN"
                [max]="BORDER_RADIUS_MAX"
                [onlyIntegers]="true"
                [value]="borderRadius.value"
                (valueChange)="setBorderRadius($event)"
                (blurEvent)="setBorderRadius($event)"
            ></sp-input-num>
        </div>
    </div>

    <div class="form-group mb-0">
        <label class="col-xs-6 control-label">{{ "control_fields_size" | translate }}</label>
        <div class="col-xs-6">
            <sp-radio-group
                [selected]="size.value"
                [type]="ERadioGroupType.size"
                (changeSelectedEvent)="setSize($event)"
            ></sp-radio-group>
        </div>
    </div>

    <div class="form-group mb-0">
        <div class="col-xs-12">
            <hr class="panel-options-divider" />
        </div>
    </div>
</div>
